import { render, staticRenderFns } from "./VendorEventsApprove.vue?vue&type=template&id=06cd2dfc&"
import script from "./VendorEventsApprove.vue?vue&type=script&lang=js&"
export * from "./VendorEventsApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports